module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body",
    staticClass: "section"
  }, [_c('div', [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.top), function(row, idx) {
    return _c('dd', [_c('div', {
      ref: idx,
      refInFor: true,
      staticClass: "container publicity",
      attrs: {
        "id": idx
      }
    }, [_c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[0]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[1]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[2]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[3]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-3"
    }, [_vm._v(_vm._s(row[4]))])])])
  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('div', {
    staticClass: "container publicity"
  }, [_c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("序号")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("学校")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("年级")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("作品名")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eb78e64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Top100.vue
// module id = 619
// module chunks = 1